export default "__VITE_ASSET__CxYRmc67__"